import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "ui/popover";
import { Clock } from "lucide-react";

interface TimePickerProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
}

export const TimePickerField = ({
  value,
  onChange,
  placeholder,
}: TimePickerProps) => {
  const [open, setOpen] = useState(false);

  const [hour = "00", minute = "00"] = (value || "00:00").split(":");

  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0"),
  );

  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0"),
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="w-full flex items-center justify-between border rounded-md px-3 py-2 bg-white cursor-pointer text-left"
        >
          <span className={`text-sm ${!value ? "text-gray-400" : "text-gray-900"}`}>
            {value || placeholder || "00:00"}
          </span>

          <Clock className="w-4 h-4 text-gray-500 shrink-0" />
        </button>
      </PopoverTrigger>

      <PopoverContent className="z-[9999] w-[180px] p-2 bg-white shadow-lg pointer-events-auto">
        <div className="flex text-sm">

          {/* HOURS */}
          <div className="flex-1 max-h-48 overflow-y-auto scrollbar-hide">
  {hours.map((h) => (
    <button
      type="button"
      key={h}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange(`${h}:${minute}`);
      }}
      className={`w-full px-3 py-2 text-center cursor-pointer ${
        h === hour
          ? "bg-blue-600 text-white rounded-md"
          : "hover:bg-blue-100 rounded-md"
      }`}
    >
      {h}
    </button>
  ))}
</div>

          {/* MINUTES */}
          <div className="flex-1 max-h-48 overflow-y-auto scrollbar-hide">
  {minutes.map((m) => (
    <button
      type="button"
      key={m}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange(`${hour}:${m}`);
        setOpen(false);
      }}
      className={`w-full px-3 py-2 text-center cursor-pointer ${
        m === minute
          ? "bg-blue-600 text-white rounded-md"
          : "hover:bg-blue-100 rounded-md"
      }`}
    >
      {m}
    </button>
  ))}
</div>

        </div>
      </PopoverContent>
    </Popover>
  );
};